import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circle-half-filled-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(1.5 1)" },
        React.createElement("circle", { cx: 7, cy: 7.5, r: 7, stroke: "currentColor" }),
        React.createElement("path", { fill: "currentColor", d: "M7 .5c.168 0 .335.006.5.018v13.964A7 7 0 1 1 7 .5Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
